import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export async function scanUrl(url, device_id) {
  const r = await api.post("/scan", { url, device_id: device_id || undefined });
  return r.data;
}
export async function getScans(limit = 100, token) {
  const r = await api.get(`/scans?limit=${limit}`, { headers: { "X-Admin-Token": token } });
  return r.data;
}
export async function getStats() {
  const r = await api.get("/stats");
  return r.data;
}
export async function getSettings(token) {
  const r = await api.get("/settings", { headers: { "X-Admin-Token": token } });
  return r.data;
}
export async function setSettings(payload, token) {
  const r = await api.post("/settings", payload, { headers: { "X-Admin-Token": token } });
  return r.data;
}
export async function checkAdmin(token) {
  const r = await api.get("/admin/check", { headers: { "X-Admin-Token": token } });
  return r.data;
}
export async function reportSite(url, reason) {
  const r = await api.post("/reports", { url, reason });
  return r.data;
}
export async function getReports(limit = 25, token) {
  const r = await api.get(`/reports?limit=${limit}`, { headers: { "X-Admin-Token": token } });
  return r.data;
}
export async function getDeviceStats(token) {
  const r = await api.get("/devices/stats", { headers: { "X-Admin-Token": token } });
  return r.data;
}
export const csvUrl = `${API}/scans.csv`;
